import _capitalize from 'lodash/capitalize';
const getTypeMapping = type => {
  const mapping = {
    blog: 'Blog',
    app: 'App',
    book: 'Book',
    podcast: 'Podcast',
    video: 'Video',
    program: 'Program',
    faq: 'FAQ',
  };
  return mapping[type] || _capitalize(type);
};

export { getTypeMapping };
